import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function _templateObject4() {
  const data = _taggedTemplateLiteral(["\n    height: 100%;\n    transition: opacity 0.2s ease;\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n    position: absolute;\n    top: calc(50% - 5px);\n    left: 40vw;\n    right: 40vw;\n    height: ", "px;\n    border-radius: ", "px;\n    background: rgba(0, 0, 0, 0.3);\n\n    &::after {\n        content: '';\n        display: block;\n        width: 40%;\n        border-radius: ", "px;\n        height: 100%;\n        background: rgba(255, 255, 255, 0.8);\n        animation: 1s ", " ease-out both;\n    }\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n  0% {\n    width: 0%;\n  }\n  100% {\n    width: 100%;\n  }\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    height: 100%;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import React, { useEffect, useRef, useState, Children } from 'react';
import styled, { keyframes } from 'styled-components';
import { ConfigContext } from '../../lib/Config';
import { Timeline, TimelineContext } from '../../lib/Timeline';
import { Controls } from '../Controls';
const WINDOW = window;
const inRenderMode = WINDOW.__RENDER__;
export const Deck = props => {
  const children = props.children,
        _props$config = props.config,
        config = _props$config === void 0 ? {} : _props$config;
  const timelineRef = useRef(new Timeline());
  const timeline = timelineRef.current;

  const _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        rdy = _useState2[0],
        setRdy = _useState2[1]; // if (inRenderMode) {


  WINDOW.__TIMELINE = timeline; // }

  useEffect(() => {
    timeline.onRegister(() => {
      setRdy(true);
    });
  }, [timeline]);
  const childrenArray = Children.toArray( // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children);
  const duration = timeline.getDuration();
  return React.createElement(Wrapper, {
    style: {
      backgroundColor: config.backgroundColor
    }
  }, !inRenderMode && React.createElement(Controls, {
    timeline: timeline
  }), inRenderMode && duration && React.createElement("div", {
    id: "duration",
    style: {
      display: 'none'
    }
  }, timeline.getDuration()), rdy || React.createElement(Loading, null), React.createElement(ConfigContext.Provider, {
    value: config
  }, React.createElement(TimelineContext.Provider, {
    value: timeline
  }, React.createElement(SlidesContainer, {
    style: {
      backgroundColor: config.backgroundColor,
      backgroundImage: "url(".concat(config.backgroundImage, ")"),
      opacity: rdy ? 1 : 0
    }
  }, childrenArray.map((child, index) => React.createElement(child.type, Object.assign({
    key: index,
    start: index + 1
  }, child.props)))))));
};
const Wrapper = styled.div(_templateObject());
const grow = keyframes(_templateObject2());
const height = 7;
const Loading = styled.div(_templateObject3(), height, height, height, grow);
const SlidesContainer = styled.div(_templateObject4());